<template>
  <v-card class="mt-2 mx-1 mb-4" elevation="5">
    <v-row class="mx-0">
      <v-col cols="12" sm="8" md="9" class="pa-3">
        <title-card :text="axis 
          ? `Cómo se construyó el Eje ${axis.nombre_corto}` : 'Metodología'"/>
        <div class="pt-2 pb-0 mx-3" v-html="content[0]"></div>
        <v-card-actions v-if="!show_metod" class="pt-0">
          <v-spacer></v-spacer>
          <v-btn color="accent" text large @click="show_metod = true">
            Leer más
            <v-icon>keyboard_arrow_down</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-col>
      <v-col cols="8" sm="4" md="3" offset="2" offset-sm="0">
        <v-row justify="center" class="mx-0" v-if="!is_equal">
          <v-col v-for="(ej, idx) in examples" align="center" class="mt-1 pb-0 px-0" cols="4">
            <v-badge
              color="transparent"
              top
              overlap
              offset-y="-10"
              offset-x="50"
            >
              <template v-slot:badge>
                <b class="title black--text">
                  {{format_perc(ej.value)}}
                </b>
              </template>
              <BubbleChart 
                :ies="{id: 1000+idx, siglas: ej.nota, nombre:'ex'}"
                :col="{id: idx, color:axis? axis.color: color_idx,
                  nombre_corto: ''}"
                _axis="{id: idx, color:axis ? axis.color : color_idx,
                  nombre_corto: ''}"
                :axis="axis"
                :value="ej.value"
                :mean="'examp'"
              />
            </v-badge>
          </v-col>
          <v-col cols="12" align="center" class="pt-2 pb-0">
            Niveles de avance (según tamaño)
          </v-col>
        </v-row>
        <Legend v-else/>
      </v-col>
    </v-row>
    <v-row class="mx-0 px-3 mx-3">
      <template v-if="show_metod">
        <span v-html="content[1]"/>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="show_metod = false">Ocultar Metodología</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </template>
    </v-row>
  </v-card>
</template>


<script>

import BubbleChart from "../charts/BubbleChart";
import homeMixin from "../homeMixin";
import Legend from "../charts/Legend";
import { mapState, } from "vuex";
import TitleCard from "../common/TitleCard";

export default {
  name: 'Methodology',
  components: {
    BubbleChart,
    Legend,
    TitleCard,
  },
  mixins: [homeMixin],
  props:{
    is_equal:{
      type: Boolean,
      required: false,
      default: false,
    },
    axis:{
      type: Object,
      required: false,
    },
  },
  data(){
    return {
      show_metod: false,
      octagono: require("@/assets/octagono.png"),
      examples : [{"value": 0, 'nota':'Incipiente'},
        {"value": 2.5, 'nota':'Intermedio'},
        {"value": 5, 'nota':'En vías de consolidación'}],
    }
  },
  computed:{
    ...mapState({
      page_setup: state => state.page_setup,
    }),
    axis_id: (vm) => vm.axis && vm.axis.id || 99,
    content(){
      var base
      if (this.axis)
        base = this.axis.descripcion
      else{
        if (this.page_setup)
          base = this.page_setup.methodology
        else
          return ["cargando...", " "]
      }
      return base.split("<hr />")
    },
  },
}
</script>

<style lang="scss" scoped>
</style>